<template>
<section>
  <div style="background: white; padding:5px">
    <b-field grouped group-multiline>
      
      
      <b-field>
        <span class="panel-icon" style="font-size:1.3em;">
            <!-- TODO  -->
            <i v-if="contact.status.custclass === 4" class="fas fa-trophy" style="color: gold;" aria-hidden="true"></i>
            <i v-if="contact.status.custclass === 3" class="fas fa-trophy" style="color: silver;" aria-hidden="true"></i>
            <i v-if="contact.status.custclass === 2" class="fas fa-trophy" style="color: orange;" aria-hidden="true"></i>
            <i v-if="contact.status.custclass === 1" class="fas fa-trophy" style="color: black;" aria-hidden="true"></i>
          </span>
      </b-field>
     
    </b-field>  
    <!-- <b-field grouped group-multiline style="line-height: 0.3;">
      <b-field>
        <span style="font-size: 0.8em;">{{contact.message}}</span>
      </b-field>
      <b-field>

    
        <span style="font-size: 0.8em;">{{contact.status}}</span>
      </b-field>
    </b-field>   -->
  </div>
    
</section>
</template>

<script>

export default {

  name: 'ShowClassification',
  components: {
    
  },
  // data() {
  //   return  {
  //   }
  // },
  props: {
    contact: {},
  },
  computed: {
    // isRead: this.contact.status==='read' ? true: false
  },
  methods: {
    // isread (status) {
    //   if (status==='read') return true;
    //   return false;
    // }
    // clickMe () {
    //   window.alert(this.msg)
    // }
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .read {
    background: green;
  }
</style>